import React from 'react';
import { useHits } from 'react-instantsearch';
import NoResultsBoundary from './NoResultsBoundary';
import { Link } from 'gatsby';
import BlogCard from "./BlogCard";

export default function BlogHits() {
  const { hits, results, sendEvent } = useHits();
  return (
      <>
        <p className="text-lg ml-2 mb-1 mt-4 pb-2 font-bold">From The Campfire</p>
        <NoResultsBoundary fallback={null}>
          <div className="flex flex-wrap">
            {hits.map((hit) => (
                <Link
                    key={hit.objectID}
                    to={`/blogs/campfire-chats/${hit.objectID}`}
                    className="no-underline text-white box-border w-1/3 min-w-[120px] p-2 mb-2"
                    onClick={() => sendEvent('click', hit, 'Product clicked')}
                    onAuxClick={() => sendEvent('click', hit, 'Product clicked')}
                >
                  <BlogCard key={hit.objectID} blog={hit}/>
                </Link>
            ))}
          </div>
        </NoResultsBoundary>
      </>
  );
}
